import { Button, Checkbox, Field, FileField, Input, Select } from '@itds/elements/index.js';
import React, { useContext, useState } from 'react';

import { ACTION_MESSAGES } from '@carrier/utils/custom_hooks/useNotification';
import Api from '@carrier/utils/Api';
import { CarrierContext } from '@carrier/contexts/CarrierContext';
import PropTypes from 'prop-types';
import { STATES } from '@itds/Constants';

const General = ({ carrier, loadCarrier }) => {
  const { setNotification } = useContext(CarrierContext);
  const [data, setData] = useState({
    logo: carrier.logo || '',
    name: carrier.name || '',
    is_agency_specific: carrier.is_agency_specific,
    is_default: carrier.is_default,
    is_live: carrier.is_live,
    street1: carrier.street1 || '',
    street2: carrier.street2 || '',
    city: carrier.city || '',
    state: carrier.state || '',
    zipcode: carrier.zipcode || '',
    phone: carrier.phone || '',
    email: carrier.email || '',
    insureio_id: carrier.insureio_id || '',
    applicint_id: carrier.applicint_id || '',
    amb_number: carrier.amb_number || '',
    comdex_score: carrier.comdex_score || '',
    naic_code: carrier.naic_code || '',
    comdex_as_of: new Date(carrier.comdex_as_of).toLocaleDateString('en-US') || '',
    fl_code: carrier.fl_code || '',
    internal_note: carrier.internal_note || ''
  });
  const [saving, setSaving] = useState(false);

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleCheckboxChange = (name, e) => {
    setData({ ...data, [name]: e.target.checked });
  };

  const handleLogoChange = file => {
    setData({ ...data, logo: file });
  };

  const handleSave = () => {
    setSaving(true);

    Api.saveCarrier(carrier.id, data).then(() => {
      setSaving(false);
      setNotification(ACTION_MESSAGES.CARRIERS.GENERAL.SAVE);
      loadCarrier();
    });
  };

  return (
    <>
      <Field label='Logo'>
        {data.logo && data.logo.url ? (
          <img
            src={`${data.logo.url}?${new Date().getTime()}`} // force cache update so new image displays
            style={{ height: 100, width: 'auto', margin: '0 0 20px 0' }}
          />
        ) : null}

        <FileField
          file={data.logo}
          fileUrl={data.logo ? data.logo.url : ''}
          onChange={handleLogoChange}
        />
      </Field>

      <Field label='Name'>
        <Input onChange={handleInputChange.bind(null, 'name')} value={data.name} />
      </Field>

      <Field>
        <Checkbox
          checked={data.is_agency_specific}
          label='Agency specific carrier'
          onChange={handleCheckboxChange.bind(null, 'is_agency_specific')}
        />
      </Field>

      <Field>
        <Checkbox
          checked={data.is_default}
          label='Enabled by default on new products'
          onChange={handleCheckboxChange.bind(null, 'is_default')}
        />
      </Field>

      <Field>
        <Checkbox
          checked={data.is_live}
          label='Live'
          onChange={handleCheckboxChange.bind(null, 'is_live')}
        />
      </Field>

      <Field label='Street 1'>
        <Input onChange={handleInputChange.bind(null, 'street1')} value={data.street1} />
      </Field>

      <Field label='Street 2'>
        <Input onChange={handleInputChange.bind(null, 'street2')} value={data.street2} />
      </Field>

      <div style={{ display: 'flex' }}>
        <Field label='City' style={{ flex: 1 }}>
          <Input onChange={handleInputChange.bind(null, 'city')} value={data.city} />
        </Field>

        <Field label='State' style={{ margin: '0 10px' }}>
          <Select
            onChange={handleInputChange.bind(null, 'state')}
            options={[{ value: '', label: '-- Select One --' }].concat(STATES)}
            value={data.state}
          />
        </Field>

        <Field label='Zip Code'>
          <Input onChange={handleInputChange.bind(null, 'zipcode')} value={data.zipcode} />
        </Field>
      </div>

      <div style={{ display: 'flex' }}>
        <Field label='Phone' style={{ flex: 1, marginRight: 10 }}>
          <Input onChange={handleInputChange.bind(null, 'phone')} value={data.phone} />
        </Field>

        <Field label='Email' style={{ flex: 1 }}>
          <Input onChange={handleInputChange.bind(null, 'email')} value={data.email} />
        </Field>
      </div>

      <Field label='Insure.io ID'>
        <Input onChange={handleInputChange.bind(null, 'insureio_id')} value={data.insureio_id} />
      </Field>

      <Field label='ApplicInt ID'>
        <Input onChange={handleInputChange.bind(null, 'applicint_id')} value={data.applicint_id} />
      </Field>

      <Field label='AMBest Number'>
        <Input onChange={handleInputChange.bind(null, 'amb_number')} value={data.amb_number} />
      </Field>

      <Field label='FireLight Code'>
        <Input onChange={handleInputChange.bind(null, 'fl_code')} value={data.fl_code} />
      </Field>
      <div style={{ display: 'flex', width: '100%', gap: '10px' }}>
        <Field label='Company Comdex'>
          <Input
            onChange={handleInputChange.bind(null, 'comdex_score')}
            type='number'
            value={data.comdex_score}
          />
        </Field>
        <Field label='Naic Code '>
          <Input
            onChange={handleInputChange.bind(null, 'naic_code')}
            type='number'
            value={data.naic_code}
          />
        </Field>
        <Field label='Comdex As Of'>
          <Input
            onChange={handleInputChange.bind(null, 'comdex_as_of')}
            placeholder='MM/DD/YYYY'
            type='text'
            value={data.comdex_as_of}
          />
        </Field>
      </div>

      <Field label='Internal Note'>
        <Input
          height={200}
          onChange={handleInputChange.bind(null, 'internal_note')}
          type='textarea'
          value={data.internal_note}
        />
      </Field>

      <Button
        disabled={saving}
        icon={saving ? 'loading mdi-spin' : null}
        inline={true}
        onClick={handleSave}
      >
        {saving ? 'Saving...' : 'Save Changes'}
      </Button>
    </>
  );
};

General.propTypes = {
  carrier: PropTypes.object,
  loadCarrier: PropTypes.func
};

export default General;
